'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LockIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LockIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        id="Lock-6--Streamline-Ultimate"
        height="24"
        width="24"
        style={{ opacity: 0.56 }}
      >
        <desc>Lock 6 Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M18.75 10.06V6.75a6.75 6.75 0 0 0 -13.5 0v3.31A5 5 0 0 0 2.5 14.5V19a5 5 0 0 0 5 5h9a5 5 0 0 0 5 -5v-4.5a5 5 0 0 0 -2.75 -4.44ZM14 16.45a2 2 0 1 1 -2 -2 2 2 0 0 1 2 2ZM12 2.5a4.26 4.26 0 0 1 4.25 4.25V9a0.5 0.5 0 0 1 -0.5 0.5h-7.5a0.5 0.5 0 0 1 -0.5 -0.5V6.75A4.26 4.26 0 0 1 12 2.5Z"
          fill="#3D517B"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

LockIcon.propTypes = {
  sx: PropTypes.object
}
